






























































import _ from "lodash";

import { Component, Vue } from "vue-property-decorator";
import { Contractor } from "@/models";
import { Action, Getter, Mutation } from "vuex-class";

@Component
export default class ContractorList extends Vue {
  @Getter("app/hasBlockingRequests") public hasBlockingRequests: boolean;
  @Getter("contractors/list") public list: Contractor[];

  @Action("contractors/getContractors") getContractors: () => Promise<void>;

  @Mutation("contractors/setCurrent")
  public setCurrent: (contractors: Contractor) => void;

  @Action("contractors/deleteContractors") deleteStoreContractors: (
    contractors: Contractor
  ) => Promise<void>;

  public mounted() {
    Promise.all([this.getContractors()]).catch((err: any) =>
      this.$onecentral.displayError(err)
    );
  }

  public editContractors(contractors: Contractor): void {
    this.setCurrent(contractors);
    this.$router.push({
      name: "edit-contractors",
      params: { id: contractors.id || "" }
    });
  }

  public deleteContractors(contractors: Contractor): void {
    this.$onecentral
      .confirmPrompt()
      .then(() => this.deleteStoreContractors(contractors))
      .then(() => Vue.toasted.success("Contractors deleted"))
      .catch((err: any) => this.$onecentral.displayError(err));
  }
}
